module.exports = __webpack_public_path__ + "static/TiemposHeadlineWeb-Semibold-9fb89fa0106edf0138598348838a0792.woff";